var map = {
  "./mobile/Topic.scss": [
    "70405",
    7,
    "99498"
  ],
  "./desktop/Topic.js": [
    "97465",
    9,
    "9598",
    "59264",
    "66399"
  ],
  "./desktop/index": [
    "54892",
    9,
    "9598",
    "59264",
    "66399",
    "48989"
  ],
  "./desktop/index.js": [
    "54892",
    9,
    "9598",
    "59264",
    "66399",
    "48989"
  ],
  "./mobile/Topic.js": [
    "46605",
    9,
    "9598",
    "59264",
    "21918",
    "44969"
  ],
  "./mobile/index.js": [
    "30082",
    9,
    "9598",
    "59264",
    "21918",
    "7095"
  ],
  "./mobile": [
    "30082",
    9,
    "9598",
    "59264",
    "21918",
    "7095"
  ],
  "./desktop": [
    "54892",
    9,
    "9598",
    "59264",
    "66399",
    "48989"
  ],
  "./desktop/": [
    "54892",
    9,
    "9598",
    "59264",
    "66399",
    "48989"
  ],
  "./mobile/": [
    "30082",
    9,
    "9598",
    "59264",
    "21918",
    "7095"
  ],
  "./mobile/Topic": [
    "46605",
    9,
    "9598",
    "59264",
    "21918",
    "44969"
  ],
  "./desktop/Topic": [
    "97465",
    9,
    "9598",
    "59264",
    "66399"
  ],
  "./mobile/index": [
    "30082",
    9,
    "9598",
    "59264",
    "21918",
    "7095"
  ],
  "./desktop/Topic.scss": [
    "87137",
    7,
    "64724"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 78565;
module.exports = __rspack_async_context;
